import React from "react";
import { createRoot } from 'react-dom/client';
import theme from "../utils/MUI/captionAI-override.js";
import CaptionAIPreviewApp from "./captionAI-preview-app.jsx";
import { ThemeProvider } from "@mui/material";
import { initRum } from '../utils/datadog.js';

initRum();

const container = document.getElementById("preview-root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CaptionAIPreviewApp />
    </ThemeProvider>
  </React.StrictMode>
);
